import "./QuestionReport.css";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Question from "./Questions/Question";

const QuestionSection = ({ question, studentId, reportRef }) => {
  return (
    <Container style={{ width: "100%", margin: "auto" }}>
      <Row className="my-5" style={{ boxShadow: "none" }}>
        {question
          .filter((q) =>
            [
              "mmcq",
              "mcq",
              "correctstatement",
              "oneword",
              "descriptive",
              "assertion-reasoning",
            ].includes(q.questionId?.questionType),
          )
          .map((q, i) => {
            const isCheckable = ["descriptive", "assertion-reasoning"].includes(
              q.questionId?.questionType,
            );
            return (
              <Question
                key={i}
                type={q.questionId.questionType}
                question={q}
                studentId={studentId}
                ind={i + 1}
                isCheckable={isCheckable}
                reportRef={reportRef}
              />
            );
          })}
      </Row>
    </Container>
  );
};

export default QuestionSection;
